export default "__VITE_ASSET__FhH4o2Ji__"